import $ from 'jquery';
import skipLinks from './utils/skipLinks';
import iframer from './utils/iframer';
import mNav from './utils/mNav';
import multiNav from './utils/multiNav';
import childTabIndex from './utils/childTabIndex';
import setupSharing from './utils/social';
// import equalHeight from './utils/equalHeight';
import googleMaps from './utils/googleMaps';
import listShowHide from './utils/listShowHide';
import setupNotices from './utils/setupNotices';

function globals () {


    // iframe video in body content
    iframer();

    // Small Screen Navigation
    mNav(
        '#navigation-primary-toggle',
        'navigation-primary-toggle--open',
        '#navigation-primary__items',
        'navigation-primary__items--open'
    );

    // Multi Navigation
    multiNav(
        '#navigation-primary',
    );

    // Set child tab index for nav
    childTabIndex(
        '#navigation-primary-toggle',
        '#navigation-primary',
        'navigation-primary--active',
        960
    );

    // Events filter
    mNav(
        '.filterBlock__title',
        'active',
        '.filters__wrap',
        'active'
    );

    // Set child tab index for nav
    childTabIndex(
        '.filterBlock__title',
        '.filters__wrap',
        'active',
        780
    );

    // google maps
    googleMaps();

    // social
    setupSharing();

    // equal height chart titles
    // equalHeight('child,child', 'parent');

    // list toggles
    listShowHide();

    // set up notices
    setupNotices();
}

$(function run () {
    console.log('ᕕ( ᐛ )ᕗ Running...');
    globals();
});
